<p>
  default-filter-page-template works!
</p>
